import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Fund Tag API
 */
class FundTagApi extends ApiBase {
  /**
   * Check if Fund Tag Name already exists
   * @param {*} fundTagName
   */
  async checkFundTagNameExists(fundTagName) {
    const request = {
      url: `${this.API_URL}/fundtag?name=${fundTagName}`,
      headers: this.getHeaders(),
      method: 'HEAD',
      validateStatus: function(status) {
        return (status >= 200 && status < 300) || status === 404;
      }
    };

    const response = await axios.request(request);

    if (response.status === 200) {
      return true;
    } else if (response.status === 404) {
      return false;
    }
  }

  /**
   * Create Fund Tag
   * @param payload { name: fundTagName }
   */
  async create(payload) {
    const request = {
      url: `${this.API_URL}/fundtag`,
      headers: this.getHeaders(),
      method: 'POST',
      data: payload
    };

    const response = await axios.request(request);

    return response.data;
  }

  /**
   * Update Fund Tag Name
   * @param id
   * @param payload { name: fundTagName, description: description }
   */
  async update(id, payload) {
    const request = {
      url: `${this.API_URL}/fundtag?id=${id}`,
      headers: this.getHeaders(),
      method: 'PUT',
      data: payload
    };

    const response = await axios.request(request);

    return response.data;
  }

  async getAll() {
    const request = {
      url: `${this.API_URL}/fundtags?orderBy=name`,
      headers: this.getHeaders(),
      method: 'GET'
    };

    const response = await axios.request(request);

    return response.data;
  }
  async downloadFundTagImportTemplate() {
    const request = {
      url: `${this.API_URL}/fundtag/import/template`,
      method: 'GET',
      headers: this.getHeaders(),
      responseType: 'blob'
    };

    const response = await axios.request(request);
    return response.data;
  }

  async validateImportFromExcel(payload) {
    const request = {
      url: `${this.API_URL}/fundtag/validateimport`,
      method: 'POST',
      headers: this.getHeaders(),
      data: payload
    };
    const response = await axios.request(request);
    return response.data;
  }

  async importFundTagFromExcel(payload) {
    const request = {
      url: `${this.API_URL}/fundtag/importexcel`,
      method: 'POST',
      headers: this.getHeaders(),
      data: payload
    };
    const response = await axios.request(request);
    return response.data;
  }

  async exportFundTagToExcel(nameFilter, selectedIds) {
    if (nameFilter.trim() === '') {
      nameFilter = undefined;
    } else {
      nameFilter = '*' + nameFilter + '*';
    }

    let payload;
    if (selectedIds && selectedIds.length > 0) {
      payload = {
        tagIds: selectedIds
      };
    } else {
      payload = {
        name: nameFilter
      };
    }

    const request = {
      url: `${this.API_URL}/fundtags/excel/export`,
      method: 'POST',
      headers: this.getHeaders(),
      responseType: 'blob',
      data: payload
    };

    const response = await axios.request(request);
    return response.data;
  }
}

export default new FundTagApi();
